module.exports = __webpack_public_path__ + "static/media/microsoft_logo.32908b1b.svg";